<template>
  <div class="setting">
    <!-- <CDNbreadcrumbs :items="items" /> -->

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'products' }">{{$t('product.myProduct')}}</el-breadcrumb-item>
  <el-breadcrumb-item :v-if="this.product">{{this.product.name}} | {{$t('product.Statistics')}}</el-breadcrumb-item>
</el-breadcrumb>

    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane lazy :label="$t('product.flow')" name="first">
        <StaticData
          v-if="activeName === 'first'"
          mytype="flows"
          name="product" 
          :id="this.pid.toString()"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.statuscode')" name="second">
        <StaticData
          v-if="activeName === 'second'"
          mytype="codes"
          name="product" 
          :id="this.pid.toString()"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.hitrate')" name="third">
       <StaticData
          v-if="activeName === 'third'"
          mytype="hits"
          name="product" 
          :id="this.pid.toString()"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.defense')" name="four">
         <StaticData
          v-if="activeName === 'four'"
          mytype="wafs"
          name="product" 
          :id="this.pid.toString()"
         />
    </el-tab-pane>
     <!-- <el-tab-pane label="演示" name="demo">
         <StaticDataDemo
          v-if="activeName === 'demo'"
          mytype="wafs"
          name="product" 
          :id="this.pid.toString()"
         />
    </el-tab-pane> -->
  </el-tabs>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { productDetail } from '@/service/requestRes';
import StaticData from '@/views/products/StaticData.vue';
import StaticDataDemo from '@/views/products/StaticDataDemo.vue';

export default {
  props: {
    type: String,
    current_host: String,
  },
  components: {
    StaticData,
    StaticDataDemo,
  },
  data() {
    return {
      pid: this.$route.params.pid,
      product: {name: null},
      activeName: 'first',
    };
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('product.productlist'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('product.Statistics'),
        },
      ];
    },
  },
  mounted() {
    // this.pid = this.$route.params.pid;
    this.getProductDetail(this.pid);
  },
  methods: {
    getProductDetail() {
      productDetail(
          this.pid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.product = data;
            window.console.debug(data);
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.setting {
    background-color: white;
    padding: 24px;
}
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
